<template>
    <textarea
        :class="classNames"
        :placeholder="placeHolder"
        ref="textArea"
        @focus="resize"
        @change="resize"
		:aria-label="ariaLabel"
        v-model="useInput"/>
</template>

<script>
export default {
    props: {
        minHeight: {
            type: Number,
            default: null
        },
        maxHeight: {
            type: Number,
            default: null
        },
        classNames: {
            type: String,
            default: ""
        },
        placeHolder: {
            type: String,
            default: ""
		},
		ariaLabel: {
			type: String,
			default: '',
		},
		inputVal: {
			type: String,
			default: '',
		},
	},
	data() {
		return {
			useInput: '',
		}
	},
    methods: {
        resize(textLength) {
			const textArea = this.$refs.textArea;
            const height = textArea.scrollHeight + 1;
            // todo, deal with maxheight and minheight, and resizing. doesn't resize as you type
			if (height > 42) {
				textArea.style.setProperty('height', `${height}px`);
			}
			if (textLength === 0) {
				textArea.style.setProperty('height', `2.6em`);
			}
        }
    },
    watch: {
        useInput(newVal, oldVal) {
			if (newVal !== oldVal) {
				this.$emit('input', newVal);
				this.resize(newVal.length);
			}
		},
	},
	mounted() {
		setTimeout(() => {
			this.useInput = this.inputVal;
		}, 0);
	}
}
</script>
<style lang="scss" scoped>
	textarea {
		padding-top: 7px;
		transition: height .5s;
	}
</style>




// WEBPACK FOOTER //
// src/components/common/BaseResizeableTextArea.vue